export const workspace = {
  routes: [
    {
      path: "/workspace/library/receiver-group",
      component: () => import("../workspace-library-receiver-group-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
